export enum StoreActionName {
  setLastSearchQuery = 'setLastSearchQuery',
  setLastAskAiNotesSearchQuery = 'setLastAskAiNotesSearchQuery',
  toggleSearchModal = 'toggleSearchModal',
}
// TODO: when decided on ts strategy upgrade this file
export interface ITeamProject {
  id: string;
  team_id: string;
  name: string;
  title: string;
  content: string;
  thumbnail_url: string;
  overview_page_id: string;
  user_id_posted: string;
  user_id_last_updated: string;
  time_created: string;
  time_updated: string;
  total_members: string;
  total_members_online: string;
}

export interface ISearchResultsBoard {
  id: string;
  project_id: string;
  title: string;
}

export interface ISearchResultsCard {
  board_name: string;
  id: string;
  list_name: string;
  members: any[];
  project_id: string;
  title: string;
}

export interface ISearchResultsPage {
  excerpt: string;
  id: string;
  project_id: string;
  title: string;
}

export interface ISearchResultsProject {
  id: string;
  time_created: number;
  title: string;
  total_members: number;
  user_id: string;
}

export interface ISearchResults {
  boards: ISearchResultsBoard[];
  cards: ISearchResultsCard[];
  pages: ISearchResultsPage[];
  projects: ISearchResultsProject[];
}
